import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';

import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';

import SuspenseLoader from 'src/components/SuspenseLoader';
import { RequireAuth } from './components/RequireAuth';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Pages


// Dashboards
const Tasks = Loader(lazy(() => import('src/content/dashboards/finances')));
const MonthlyStatement = Loader(lazy(() => import('src/content/dashboards/finances/MonthlyStatement')));

// Applications
const Transactions = Loader(
  lazy(() => import('src/content/applications/Transactions'))
);
const Categories = Loader(
  lazy(() => import('src/content/applications/Categories'))
);
const Funds = Loader(
  lazy(() => import('src/content/applications/Funds'))
);
const UserProfile = Loader(
  lazy(() => import('src/content/applications/Users/profile'))
);
const UserSettings = Loader(
  lazy(() => import('src/content/applications/Users/settings'))
);

// Login
const Login = Loader(lazy(() => import('src/pages/Login')));

//home
const Home = Loader(lazy(() => import('src/pages/Home')));

// Status
const Status404 = Loader(
  lazy(() => import('src/content/pages/Status/Status404'))
);

const routes: RouteObject[] = [
  {
    path: '',
    element: <BaseLayout />,
    children: [
      {
        path: '/',
        element: <Home />
      },
      {
        path: 'login',
        element: <Login />
      },
      {
        path: '*',
        element: <Status404 />
      }
    ]
  },
  {
    path: 'dashboard',
    element: <RequireAuth><SidebarLayout /></RequireAuth>,
    children: [
      {
        path: '',
        element: <Tasks />
      },
      {
        path: 'monthly-statement',
        element: <MonthlyStatement />
      }
    ]
  },
  {
    path: 'transacoes',
    element: <RequireAuth><SidebarLayout /></RequireAuth>,
    children: [
      {
        path: '',
        element: <Transactions />
      }
    ]
  },
  {
    path: 'categorias',
    element: <RequireAuth><SidebarLayout /></RequireAuth>,
    children: [
      {
        path: '',
        element: <Categories />
      }
    ]
  },
  {
    path: 'fundos',
    element: <RequireAuth><SidebarLayout /></RequireAuth>,
    children: [
      {
        path: '',
        element: <Funds />
      }
    ]
  },
  {
    path: 'perfil',
    element: <RequireAuth><SidebarLayout /></RequireAuth>,
    children: [
      {
        path: '',
        element: <Navigate to="detalhes" replace />
      },
      {
        path: 'detalhes',
        element: <UserProfile />
      },
      {
        path: 'configuracoes',
        element: <UserSettings />
      }
    ]
  }
];

export default routes;
